function clearKenticoRule(rawRule){
  
  let [ruleWithoutUser] = rawRule.split('|(user)');
  let [rule] = ruleWithoutUser.split('|(identity)');

  const action = rule.replace(/{%/, '').replace(/%}/, '');

  return action;
}

function getKenticoMethodBody(action : string){
  return  `
  // Stuff we need to run Kentico comparisons
  // !!!! React specific changes 
  var Fields = fieldsMapper;   
  var Value = value;
  // var Utils=Util;
  // !!!! END React specific changes 
  
  // Example of Kentico visibility rules:
  // Value < Fields["0cf21467-a30d-43c5-a6c6-b7f7971bf73c"].Value)
  // (ToDateTime(Value) >= ToDateTime("3/11/2019 3:12:47 PM"))
  // (Value.Matches("/[a-z]+/g")
  // (Util.IsEmail(Value))
  // Utils.hasValue(Fields.Opzegdatum.Value)
  // Fields.Opzegdatum.Valid
  
  // Kentico Conversion methods
  var ToDateTime=function(date){
    // This is not failsafe on all browsers. We should use framework instead.
    return new Date(date);
  }
  
  // Kentico Matches method
  String.prototype.Matches=function(regex) {
    return (this.match(regex) || []).length > 0;
  }
  
  try{
    // Execute Kentico macro as javascript
    return ${action};
  }
  catch(e)
  {
    // Parsing can go wrong, and the vailidation itself might contain methods not yet implemented here
    // In case a Kentico Rule fails, we log the rule plus the error in the console, so we can fix it.
    console.log("Error executing kentico rule:");
    console.log(e)
  
    // By default, failing validation code should pass as a "succesful validation"
    return true;
  }
  `;
  }

export class KenticoRulesHelper {  
  
  /**
   * getValidationMethodFromKenticoRule translates the clear text validation rule from Kentico into a working Javascript method
   *
   * To get there, we need to execute the clear text code into working Javascript.
   * For that, we use two parsing-steps:
   * 1: To extract the actual code that defines the rule
   * 2: To convert the rule into a working Javascript method.
   *
   * @param rawRule
   */
  static getValidationMethodFromKenticoRule(rawRule: string) {


    // Input from Kentico is something like:
    // tslint:disable-next-line: max-line-length
    // {%Rule("(Value < Fields[\"0cf21467-a30d-43c5-a6c6-b7f7971bf73c\"].Value)", "<rules><r pos=\"0\" par=\"\" op=\"and\" n=\"CompareToField\" ><p n=\"field\"><t>HaseflatsID</t><v>0cf21467-a30d-43c5-a6c6-b7f7971bf73c</v><r>0</r><d></d><vt>text</vt><tv>0</tv></p><p n=\"operator\"><t>Is less than</t><v><</v><r>0</r><d></d><vt>text</vt><tv>0</tv></p></r></rules>")|(user)pkaptein|(hash)cde2ae63a31948f3d5d42687396a7cab2581d5f5140dd7bcc692cadeddb0b593%}
    // console.log(rawRule);

    // ===
    // STEP 1: Discard everything not relevant.
    //
    const rule = clearKenticoRule(rawRule);
    // console.log(rule);

    // ===
    // STEP 2: Execute Rule. (This simplifies the extraction process)
    //
    // Short: a Rule from Kentico has two string values: the rule as code and the rule as XML.
    // We represent that as:  extraction function(action, rulesXml)

    const [action, rulesXml] = new /* extraction */ Function(`
    // Input is a Rule-method with an action and the XML that defines the rule in Kentico

    // To keep parsing simple, we use the given Rule method to return those values in an array.
    var Rule=function(action, rulesXml){
      return [action, rulesXml]
    }
    try{
      // Return the array
      return ${rule}
    }catch(e){
      // In case a Kentico Rule can't be parsed, we notify in the console
      console.log(e)
      return ['true',rulesXml]
    }
    `)();

    /*
    rules are embedded XML definition of the method given in action
    Here we can translate and return that object
    const x2js = new X2JS();
    const rulesAsObject = x2js.xml2js(rulesXml);
    console.log(rulesAsObject);
    */

    // Debug-log result: clean code that is ready to execute
    //console.log(action);

    // ===
    // STEP 3: Create the validator-method
    //

    // We input the form/formController and the formControl,
    // We pass "form" to expose all kinds of handy things we might need for the validations
    // For now (debugging) we put the kenticoMethod in a separate constant, so we can console-log it


    // ===
    // STEP 4: Convert the Kentico Validation Rule into a working function
    // !!!! React specific changes 
    const validationFunction = new /* validation */ Function(
      // Input parameters
      'fieldsMapper', 
      'value', 
      'Utils', 
      // Method body
      getKenticoMethodBody(action)
    );

    // Done.
    return validationFunction as (fieldsMapper: any, value: any, utils : any) => any;
  }

  static getValidationMethodFromRegex(regex: string) {
    const validationFunction = new /* validation */ Function(
      // Input parameters
      'fieldsMapper', 
      'value', 
      'Utils', 
      // Method body
      getKenticoMethodBody(regex)
    );

    // Done.
    return validationFunction as (fieldsMapper: any, value: any, utils : any) => any;
  }

  static getErrorNameFromKenticoRule(kenticoRule: any) {
    // Remove everything not wanted in a variable name
    return kenticoRule._errormsg.replace(/[^\w]/g, '');
  }

  
  static getMacroMethodFromKenticoMacroRule(rawRule: string) {

    // Input from Kentico is something like:
    // tslint:disable-next-line: max-line-length
    // {%Rule("(Value < Fields[\"0cf21467-a30d-43c5-a6c6-b7f7971bf73c\"].Value)", "<rules><r pos=\"0\" par=\"\" op=\"and\" n=\"CompareToField\" ><p n=\"field\"><t>HaseflatsID</t><v>0cf21467-a30d-43c5-a6c6-b7f7971bf73c</v><r>0</r><d></d><vt>text</vt><tv>0</tv></p><p n=\"operator\"><t>Is less than</t><v><</v><r>0</r><d></d><vt>text</vt><tv>0</tv></p></r></rules>")|(user)pkaptein|(hash)cde2ae63a31948f3d5d42687396a7cab2581d5f5140dd7bcc692cadeddb0b593%}
    // console.log(rawRule);

    // ===
    // STEP 1: Discard everything not relevant.
    //

    const action = clearKenticoRule(rawRule);
    //console.log(action);

    // ===
    // STEP 2: Convert the Kentico Validation Rule into a working function
    // !!!! React specific changes 

    const macroFunction = new /* validation */ Function(
      // Input parameters
      'fieldsMapper', 
      'value', 
      'Utils', 
      // Method body
      getKenticoMethodBody(action)
    );
    // Done.
    return macroFunction as (fieldsMapper: any, value: any, Utils : any) => any;
  }
}
